import { acknowledgeConversion, fetchPendingConversion } from "./api";
import { pushGtmEvent } from "./gtm";

/** Guards against two mounts in the same page racing each other to the same conversion. */
let inFlight: Promise<void> | null = null;

export async function reportPendingPurchaseConversion(): Promise<void> {
  if (inFlight) return inFlight;
  inFlight = (async () => {
    try {
      const pending = await fetchPendingConversion();
      if (!pending) return;
      pushGtmEvent("purchase", {
        value: pending.value,
        currency: pending.currency,
        transaction_id: pending.transaction_id,
      });
      // Acknowledged only after the push.
      await acknowledgeConversion(pending.transaction_id);
    } catch {
      /* measurement, not the product — never surface this to the customer */
    } finally {
      inFlight = null;
    }
  })();
  return inFlight;
}

/** Tests only: drop the in-page guard between cases. */
export function _resetPurchaseConversionReporting(): void {
  inFlight = null;
}
